import { render, staticRenderFns } from "./LibraryDetails.vue?vue&type=template&id=5f31fd1e&scoped=true&"
import script from "./LibraryDetails.vue?vue&type=script&lang=js&"
export * from "./LibraryDetails.vue?vue&type=script&lang=js&"
import style0 from "./LibraryDetails.vue?vue&type=style&index=0&id=5f31fd1e&lang=scss&scoped=true&"
import style1 from "./LibraryDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31fd1e",
  null
  
)

export default component.exports